<template>
    <div>
        <ErrorAlert :message="message" :error="error" />
        <StageComplete v-if="stageComplete" :message="message" :error="error" />

        <div v-else>
            <div class="">
                <h6 class="font-weight-bold mb-4">Authorised Individual(s)</h6>
                <transition name="slide-in-left">
                    <div v-if="!showForm" class="record-type-group bg-white mb-4">
                        <div class="row">
                            <div class="col-12">
                                <h4 class="text-2 mb-3">Submitted Authorised individual(s)</h4>
                                <div class="table-container">
                                    <div class="d-none d-sm-flex transaction-title py-2 px-2 border-bottom">
                                        <div class="col-2">Name</div>
                                        <div class="col-2">Surname</div>
                                        <div class="col-3">Email</div>
                                        <div class="col-2">Phone</div>
                                        <div class="col-2">Documents</div>
                                    </div>

                                    <div v-for="(row, index) in data.authorised_individuals" :key="index" :class="{ 'highlighted-row': selectedRow === index }" class="d-flex flex-column border-bottom py-3 px-2">
                                        <div class="d-none d-sm-flex align-items-center">
                                            <div class="col-lg-2">{{ row.name }}</div>
                                            <div class="col-lg-2">{{ row.surname }}</div>
                                            <div class="col-lg-3">{{ row.email }}</div>
                                            <div class="col-lg-2">{{ row.phone }}</div>
                                            <div class="col-lg-2">
                                                <span class="text-success">
                                                    <CheckMark />
                                                </span>
                                                Submitted
                                            </div>
                                        </div>
                                    </div>
                                    <div v-for="row in data.authorised_individuals" class="row d-block d-md-none border-top border-bottom py-2">
                                        <div class="col-12">
                                            <p class="text-2 mb-0">Name: <b>{{ row.name }}</b></p>
                                        </div>
                                        <div class="col-12 mb-1">
                                            <p class="text-2 mb-0">Surname: <b>{{ row.surname }}</b></p>
                                        </div>
                                        <div class="col-12 mb-1">
                                            <p class="text-2 mb-0">Phone: <b>{{ row.phone }}</b></p>
                                        </div>
                                        <div class="col-12 mb-1">
                                            <p class="text-2 mb-0">Email: <b>{{ row.email }}</b></p>
                                        </div>
                                        <div class="col-12 mb-1">
                                            <p class="text-2 mb-0">Identification: <b>Submitted</b></p>
                                        </div>
                                        <div class="col-12 mb-1">
                                            <p class="text-2 mb-0">Proof of Address: <b>Submitted</b></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="alert alert-success text-center d-flex flex-column">
                                    <span class="text-success">
                                        <CheckMark class="text-8 pt-2" />
                                    </span>
                                    <p class="mt-2 text-3">Authorised individual added successfully!</p>
                                    <div class="d-flex flex-row align-items-center justify-content-center mb-3">
                                        <button
                                            class="btn btn-success btn-sm mt-2 mr-2"
                                            @click="toggleForm"
                                            :class="{ 'btn-loading': loading }"
                                        >
                                            Add Another Authorised Individual
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <transition name="slide-in-left">
                    <div v-if="showForm" class="record-type-group bg-white mb-4">
                        <h6 class="text-3 mb-2">Details</h6>
                        <hr>
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        v-model="form.name"
                                        class="form-control"
                                        placeholder="Enter Name"
                                    />
                                    <div v-text="form.errors.get('name')" class="text-danger font-12"></div>
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label>Surname</label>
                                    <input
                                        type="text"
                                        v-model="form.surname"
                                        class="form-control"
                                        placeholder="Enter Surname"
                                    />
                                    <div v-text="form.errors.get('surname')" class="text-danger font-12"></div>
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label>Email</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text input-icon">
                                                <i class="fa fa-envelope"></i>
                                            </span>
                                        </div>
                                        <input type="email" v-model="form.email"
                                               :class="['form-control', form.errors.get('email') ? 'is-invalid' : '']"
                                               placeholder="Email">
                                        <div v-text="form.errors.get('email')" class="invalid-feedback"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label>Phone Number <small>(Number used for notifications)</small></label>
                                    <PhoneInput v-model="form.phone"></PhoneInput>
                                    <div v-text="form.errors.get('phone')" class="text-danger font-12"></div>
                                </div>
                            </div>
                        </div>
                        <h6 class="text-3 mb-2">Documents</h6>
                        <hr>
                        <div class="row mb-2">
                            <div class="col-lg-4 col-12 d-flex align-items-center">
                                <label class="form-label">{{ documentLabels.id }}</label>
                            </div>
                            <div class="col-lg-8 col-12">
                                <FileUpload
                                    :hide-save="true"
                                    fileType="pdf"
                                    v-model="form.id"
                                />
                                <div v-if="form.errors.get('id')" class="text-danger font-12">
                                    The {{ documentLabels.id }} field is required.
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-lg-4 col-12 d-flex align-items-center mt-2">
                                <label class="form-label">{{ documentLabels.proof }}</label>
                            </div>
                            <div class="col-lg-8 col-12">
                                <FileUpload
                                    :hide-save="true"
                                    fileType="pdf"
                                    v-model="form.proof"
                                />
                                <div v-if="form.errors.get('proof')" class="text-danger font-12">
                                    The {{ documentLabels.proof }} field is required.
                                </div>
                            </div>
                        </div>
                        <div class="text-end d-flex flex-row">
                            <button
                                class="btn btn-success btn-block mt-4"
                                @click="addAuthorisedIndividual"
                                :class="{ 'btn-loading': loading }"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </transition>
            </div>

        </div>
    </div>
</template>

<script>
import Form from "../../../core/forms/form.js";
import FileUpload from "../components/FileUpload.vue";
import StageComplete from "../components/StageComplete.vue";
import ErrorAlert from "../components/ErrorAlert.vue";
import PhoneInput from "../../custom/phone-input.vue";
import CheckMark from "../../core/Checkmark.vue";
import axios from "axios";

export default {
    name: "AuthorisedIndividuals",
    components: {
        CheckMark,
        PhoneInput,
        ErrorAlert,
        StageComplete,
        FileUpload,
    },
    props: ['message'],
    data() {
        return {
            stage: 1,
            showForm: true,
            loading: false,
            agreeToTerms: false,
            stageComplete: false,
            check: false,
            error: false,
            message: "",
            documentLabels: {
                id: 'Identification of Director or Authorized Individual',
                proof: 'Proof of Address (Authorized Individual)',
            },
            form: new Form({
                name: "",
                surname: "",
                phone: "",
                email: "",
                id: "",
                proof: "",
            }),
            data: {}
        };
    },
    methods: {
        goToNextStep() {
            if (!this.check) {
                this.error = true;
                this.message = 'No Authorised Individuals have been set for this Biller';
                return;
            }
            this.message = "";
            this.$emit("update-stage", this.stage + 3);
        },
        toggleForm() {
            this.showForm = true;
        },
        async addAuthorisedIndividual() {
            this.error = false;
            this.loading = true;
            this.form
                .upload("/business/biller-onboarding/authorised-individuals")
                .then((response) => {
                    this.message = response.data.message;
                    this.checkAuthorisedIndividuals();
                    this.loading = false;
                    this.check = true;
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = true;
                    this.message = error.response.data.error || 'Failed to add data. Please try again.';
                });
        },
        checkAuthorisedIndividuals() {
            this.error = false;
            this.loading = true;
            axios.get('/business/biller-onboarding/check-authorised-individuals')
                .then(response => {
                    this.loading = false;
                    this.showForm = false;
                    this.data = response.data.body;
                    this.check = true;
                })
                .catch(error => {
                    this.error = true;
                    this.loading = false;
                    this.check = false;
                });
        },
    },
    mounted() {
        this.checkAuthorisedIndividuals();
    }
};
</script>

<style scoped>
.record-type-group {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 25px;
    margin-bottom: 20px;
    background-color: #f9f9f9;
}
.text-danger {
    font-size: 12px;
    color: #dc3545;
}
</style>
